// React Component: DYPCollegeFeesTable.js
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { getDYPCollegeFeesDetailsList, saveDYPCollegeFeesDetailsList } from "../../../services/getAllApi";

const DYPCollegeFeesTable = ({ students, onDYPFeesDataChange }) => {
  const [formData, setFormData] = useState({});

  // Fetch DYP College Fees details
  const fetchDYPFeesDetails = async () => {
    try {
      const DYPFeesResponse = await getDYPCollegeFeesDetailsList();

      const initialData = {};
      students.forEach((student) => {
        const dypCollegeFees = DYPFeesResponse.find((fee) => String(fee.student_id) === String(student.student_id)) || {};
        initialData[student.student_id] = {
          name: dypCollegeFees.name || student.name || "",
          mobile: dypCollegeFees.mobile || student.mobile || "",
          total_fees: dypCollegeFees.total_fees || 0,
          total_fees_date: dypCollegeFees.total_fees_date || "",
          total_fees_paid: dypCollegeFees.total_fees_paid || false,

          sem1_fees: dypCollegeFees.sem1_fees || 0,
          sem1_fees_date: dypCollegeFees.sem1_fees_date || "",
          sem1_fees_paid: dypCollegeFees.sem1_fees_paid || false,

          sem2_fees: dypCollegeFees.sem2_fees || 0,
          sem2_fees_date: dypCollegeFees.sem2_fees_date || "",
          sem2_fees_paid: dypCollegeFees.sem2_fees_paid || false,

          sem3_fees: dypCollegeFees.sem3_fees || 0,
          sem3_fees_date: dypCollegeFees.sem3_fees_date || "",
          sem3_fees_paid: dypCollegeFees.sem3_fees_paid || false,

          sem4_fees: dypCollegeFees.sem4_fees || 0,
          sem4_fees_date: dypCollegeFees.sem4_fees_date || "",
          sem4_fees_paid: dypCollegeFees.sem4_fees_paid || false,

          balance_fees: dypCollegeFees.balance_fees || 0,
          balance_fees_date: dypCollegeFees.balance_fees_date || "",
          balance_fees_paid: dypCollegeFees.balance_fees_paid || false,
        };
      });

      setFormData(initialData);
      onDYPFeesDataChange(initialData);
      
    } catch (error) {
      console.error("Error fetching DYP College fees details:", error);
    }
  };

  useEffect(() => {
    fetchDYPFeesDetails();
  }, [students]);

  useEffect(() => {
    onDYPFeesDataChange(formData);
  }, [formData]);

  // Handle input changes
  const handleChange = (e, student_id) => {
    const { name, value, type, checked } = e.target;
    const updatedValue = type === "checkbox" ? checked : value;

    setFormData((prevData) => {
      const updatedStudent = {
        ...prevData[student_id],
        [name]: updatedValue,
      };

      const totalFees = parseFloat(updatedStudent.total_fees) || 0;
      const sem1_fees = parseFloat(updatedStudent.sem1_fees) || 0;
      const sem2_fees = parseFloat(updatedStudent.sem2_fees) || 0;
      const sem3_fees = parseFloat(updatedStudent.sem3_fees) || 0;
      const sem4_fees = parseFloat(updatedStudent.sem4_fees) || 0;

      let balanceFees = totalFees - (sem1_fees + sem2_fees + sem3_fees + sem4_fees);
      if (balanceFees <= 0) balanceFees = 0;

      updatedStudent.balance_fees = balanceFees;

      return { ...prevData, [student_id]: updatedStudent };
    });
  };

  const handleSubmit = async () => {
    const DYPfeesDataArray = students.map((student) => {
      const studentData = formData[student.student_id] || {};
      
      // Transform empty strings to proper values for database
      return {
        student_id: student.student_id.toString(),
        name: studentData.name || student.name || "",
        mobile: studentData.mobile || student.mobile || "",
        
        // Convert empty strings to 0 for numeric fields
        total_fees: studentData.total_fees === "" || studentData.total_fees === undefined || studentData.total_fees === null ? 0 : parseFloat(studentData.total_fees) || 0,
        total_fees_date: studentData.total_fees_date === "" || studentData.total_fees_date === undefined ? null : studentData.total_fees_date,
        total_fees_paid: studentData.total_fees_paid || false,
        
        sem1_fees: studentData.sem1_fees === "" || studentData.sem1_fees === undefined || studentData.sem1_fees === null ? 0 : parseFloat(studentData.sem1_fees) || 0,
        sem1_fees_date: studentData.sem1_fees_date === "" || studentData.sem1_fees_date === undefined ? null : studentData.sem1_fees_date,
        sem1_fees_paid: studentData.sem1_fees_paid || false,
        
        sem2_fees: studentData.sem2_fees === "" || studentData.sem2_fees === undefined || studentData.sem2_fees === null ? 0 : parseFloat(studentData.sem2_fees) || 0,
        sem2_fees_date: studentData.sem2_fees_date === "" || studentData.sem2_fees_date === undefined ? null : studentData.sem2_fees_date,
        sem2_fees_paid: studentData.sem2_fees_paid || false,
        
        sem3_fees: studentData.sem3_fees === "" || studentData.sem3_fees === undefined || studentData.sem3_fees === null ? 0 : parseFloat(studentData.sem3_fees) || 0,
        sem3_fees_date: studentData.sem3_fees_date === "" || studentData.sem3_fees_date === undefined ? null : studentData.sem3_fees_date,
        sem3_fees_paid: studentData.sem3_fees_paid || false,
        
        sem4_fees: studentData.sem4_fees === "" || studentData.sem4_fees === undefined || studentData.sem4_fees === null ? 0 : parseFloat(studentData.sem4_fees) || 0,
        sem4_fees_date: studentData.sem4_fees_date === "" || studentData.sem4_fees_date === undefined ? null : studentData.sem4_fees_date,
        sem4_fees_paid: studentData.sem4_fees_paid || false,
        
        balance_fees: studentData.balance_fees === "" || studentData.balance_fees === undefined || studentData.balance_fees === null ? 0 : parseFloat(studentData.balance_fees) || 0,
        balance_fees_date: studentData.balance_fees_date === "" || studentData.balance_fees_date === undefined ? null : studentData.balance_fees_date,
        balance_fees_paid: studentData.balance_fees_paid || false,
      };
    });

    console.log("Submitting Data:", DYPfeesDataArray);

    try {
      const response = await saveDYPCollegeFeesDetailsList(DYPfeesDataArray);
      console.log("Save response:", response);
      Swal.fire("Success", "DYP Fees Data saved successfully!", "success");

      // Use the updated data from the response instead of fetching again
      if (response.data && response.data.data) {
        const updatedDYPFeesResponse = response.data.data;

        const initialData = {};
        students.forEach((student) => {
          const dypCollegeFees = updatedDYPFeesResponse.find((fee) => String(fee.student_id) === String(student.student_id)) || {};
          initialData[student.student_id] = {
            name: dypCollegeFees.name || student.name || "",
            mobile: dypCollegeFees.mobile || student.mobile || "",
            total_fees: dypCollegeFees.total_fees || 0,
            total_fees_date: dypCollegeFees.total_fees_date || "",
            total_fees_paid: dypCollegeFees.total_fees_paid || false,
            sem1_fees: dypCollegeFees.sem1_fees || 0,
            sem1_fees_date: dypCollegeFees.sem1_fees_date || "",
            sem1_fees_paid: dypCollegeFees.sem1_fees_paid || false,
            sem2_fees: dypCollegeFees.sem2_fees || 0,
            sem2_fees_date: dypCollegeFees.sem2_fees_date || "",
            sem2_fees_paid: dypCollegeFees.sem2_fees_paid || false,
            sem3_fees: dypCollegeFees.sem3_fees || 0,
            sem3_fees_date: dypCollegeFees.sem3_fees_date || "",
            sem3_fees_paid: dypCollegeFees.sem3_fees_paid || false,
            sem4_fees: dypCollegeFees.sem4_fees || 0,
            sem4_fees_date: dypCollegeFees.sem4_fees_date || "",
            sem4_fees_paid: dypCollegeFees.sem4_fees_paid || false,
            balance_fees: dypCollegeFees.balance_fees || 0,
            balance_fees_date: dypCollegeFees.balance_fees_date || "",
            balance_fees_paid: dypCollegeFees.balance_fees_paid || false,
          };
        });

        setFormData(initialData);
        onDYPFeesDataChange(initialData);
      } else {
        // Fallback to fetch if response doesn't have data
        await fetchDYPFeesDetails();
      }
    } catch (error) {
      console.error("Error saving DYP fees:", error);
      Swal.fire("Error", "Failed to save data", "error");
    }
  };

  return (
    <div>
      <button onClick={handleSubmit} className="handle-btn">
        <p className="button-save">Save Data</p>
      </button>
      <div className="table-container-MBA-Students-list">
        <table>
          <thead>
            <tr>
              <th>Sr No.</th>
              <th>Student ID</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>DYP Total Fees/Date</th>
              <th>DYP SEM1 Fees/Date</th>
              <th>DYP SEM2 Fees/Date</th>
              <th>DYP SEM3 Fees/Date</th>
              <th>DYP SEM4 Fees/Date</th>
              <th>Balance Fees</th>
            </tr>
          </thead>
          <tbody>
            {students.map((student, index) => (
              <tr key={student.id}>
                <td>{index + 1}</td>
                <td>{student.student_id}</td>
                <td>{student.name}</td>
                <td>{student.mobile}</td>
                {[ 
                  { field: "total_fees", dateField: "total_fees_date", checkField: "total_fees_paid" },
                  { field: "sem1_fees", dateField: "sem1_fees_date", checkField: "sem1_fees_paid" },
                  { field: "sem2_fees", dateField: "sem2_fees_date", checkField: "sem2_fees_paid" },
                  { field: "sem3_fees", dateField: "sem3_fees_date", checkField: "sem3_fees_paid" },
                  { field: "sem4_fees", dateField: "sem4_fees_date", checkField: "sem4_fees_paid" },
                  { field: "balance_fees", dateField: "balance_fees_date", checkField: "balance_fees_paid" },
                ].map((DYPCollegefee, idx) => (
                  <td key={idx}>
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", padding: "5px" }}>
                      <input
                        type="number"
                        name={DYPCollegefee.field}
                        value={formData[student.student_id]?.[DYPCollegefee.field] ?? 0}
                        onChange={(e) => handleChange(e, student.student_id)}
                        style={{
                          width: "120px",
                          textAlign: "center",
                          fontWeight: DYPCollegefee.field === "balance_fees" ? "bold" : "normal",
                          color: DYPCollegefee.field === "balance_fees" ? "red" : "black",
                        }}
                        disabled={DYPCollegefee.field === "balance_fees"}
                      />
                      <input
                        type="date"
                        name={DYPCollegefee.dateField}
                        value={formData[student.student_id]?.[DYPCollegefee.dateField] || ""}
                        onChange={(e) => handleChange(e, student.student_id)}
                        style={{ width: "120px", textAlign: "center" }}
                      />
                      <input
                        type="checkbox"
                        name={DYPCollegefee.checkField}
                        checked={formData[student.student_id]?.[DYPCollegefee.checkField] || false}
                        onChange={(e) => handleChange(e, student.student_id)}
                        style={{
                          width: "18px",
                          height: "18px",
                          cursor: "pointer",
                          accentColor: formData[student.student_id]?.[DYPCollegefee.checkField] ? "green" : "red",
                        }}
                      />
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DYPCollegeFeesTable;
